import { render, staticRenderFns } from "./home_old.vue?vue&type=template&id=2a28caec&scoped=true&"
import script from "./home_old.vue?vue&type=script&lang=js&"
export * from "./home_old.vue?vue&type=script&lang=js&"
import style0 from "./home_old.vue?vue&type=style&index=0&id=2a28caec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28caec",
  null
  
)

export default component.exports